import jwt from 'jsonwebtoken';
import { localStorageKey } from '../../constants';

export const hasEmployerToken = () => {
   return localStorage.getItem(localStorageKey.employerToken) !== null;
};

// True when the token's exp claim is in the past. A token we cannot decode is
// treated as expired — it can only ever produce a 401.
const isExpiredJwt = (token) => {
   try {
      const { exp } = jwt.decode(token) || {};
      return typeof exp !== 'number' || exp * 1000 <= Date.now();
   } catch (e) {
      return true;
   }
};

// Expiry-aware: a partner token that is already dead is DELETED here rather than
// attached to requests, so KEEP/partner pages fail into their "sign in again" state
// instead of firing doomed calls with a known-bad credential.
export const hasPartnerToken = () => {
   const token = localStorage.getItem(localStorageKey.partnerToken);
   if (token === null) {
      return false;
   }

   if (isExpiredJwt(token)) {
      localStorage.removeItem(localStorageKey.partnerToken);
      return false;
   }

   return true;
};

// True only when a DE (employer) token exists AND its exp is in the future.
// hasEmployerToken() checks presence only; DEPRECATING pages gate on validity so
// nobody works on a dying AOE-backed page with a dead session (LUT-526 follow-up).
export const hasValidEmployerToken = () => {
   const token = localStorage.getItem(localStorageKey.employerToken);
   return token !== null && !isExpiredJwt(token);
};

// Email (JWT sub) of the live partner session, or undefined when there is none.
// For call sites outside React/redux that need the current user's identity
// without an AOE round-trip (the partner session is the surviving credential
// after the DE shutdown).
export const getPartnerEmailFromToken = () => {
   if (!hasPartnerToken()) {
      return undefined;
   }

   try {
      const { sub } = jwt.decode(localStorage.getItem(localStorageKey.partnerToken)) || {};
      return sub;
   } catch (e) {
      return undefined;
   }
};
